module.exports = __webpack_public_path__ + "images/backgrounds/fall/medium.a999e10749c6db57a5ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/fall/medium.jpg
// module id = 3KMG
// module chunks = 24